import React from 'react';

import { TabsTypes } from "components/Tabs/types";
import { TabsStatic } from "components/Tabs/components/Tabs/Tabs";

interface ITabProps {
  children: React.ReactElement,
  id: string,
  selected: boolean,
  tabClassname: string,
  selectedTabClassname: string
}

const Tab: React.FC<ITabProps> & TabsStatic = (props) => {

  const {
    children,
    id,
    selected,
    tabClassname,
    selectedTabClassname
  } = props;

  return (
    <button 
      data-tab-type="switch" 
      id={id} 
      className={`${tabClassname} ${selected ? selectedTabClassname : ""}`}
    >
      {children}
    </button>
  )
}
Tab.tabsRole = TabsTypes.Tab;
export default Tab